module.exports = __webpack_public_path__ + "img/zb4.727ce72b.png";